@let form = this.form();
@let singleUser = !!form?.controls.selectedUser.value;
<app-page size="full">
    <div class="d-flex align-items-center flex-wrap gap-3">
        <app-period-stepper
            (labelClick)="showWeekPicker.set(!showWeekPicker())"
            (next)="stepWeek(1)"
            (previous)="stepWeek(-1)"
            [label]="form?.controls.selectedWeek.value ? 'Week ' + form.controls.selectedWeek.value + ' · ' + form.controls.selectedYear.value : 'Kies een week'"
            [nextDisabled]="!form?.controls.selectedWeek.value || isLastSelectableWeek"
            [previousDisabled]="!form?.controls.selectedWeek.value || (form.controls.selectedYear.value === 2015 && form.controls.selectedWeek.value === 1)"
            [sub]="weekRange()"
            nextLabel="Volgende week"
            previousLabel="Vorige week">
        </app-period-stepper>
        @if (!isCurrentWeek) {
            <button (click)="goToCurrentWeek()" mat-stroked-button type="button">Deze week</button>
        }
        <app-person-switcher
            (valueChange)="form?.controls.selectedUser.setValue($event)"
            [people]="people()"
            [value]="form?.controls.selectedUser.value">
        </app-person-switcher>
        @if (singleUser) {
            <div class="week-total ms-auto">
                <span class="ui-meta">Totaal deze week</span>
                <span class="total">{{ weekTotalMinutes() | formatDuration }}</span>
                <span class="target">/ 40:00</span>
            </div>
        }
    </div>

    @if (showWeekPicker() && form) {
        <div [formGroup]="form" class="week-picker">
            <app-field for="weekly-year" label="Jaar">
                <ng-select
                    (change)="$event?.value && setWeeksForYear($event.value)"
                    [clearable]="false"
                    [items]="years()"
                    [searchable]="true"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="selectedYear"
                    labelForId="weekly-year"
                    placeholder="Jaar">
                </ng-select>
            </app-field>
            <app-field for="weekly-week" label="Week">
                <ng-select
                    [clearable]="false"
                    [items]="weeks()"
                    [searchable]="true"
                    bindLabel="name"
                    bindValue="value"
                    formControlName="selectedWeek"
                    labelForId="weekly-week"
                    placeholder="Week">
                </ng-select>
            </app-field>
            <button (click)="showWeekPicker.set(false)" class="align-self-end" mat-button type="button">Sluiten</button>
        </div>
    }

    <section class="board">
        <div [style.grid-template-columns]="gridColumns()" class="board-grid">
            @for (day of days(); track day.date) {
                <div [class.today]="day.today" [class.weekend]="day.weekend" class="day">
                    <div class="day-head">
                        <span class="day-title">
                            <span class="day-name">{{ day.name }}</span>
                            <span class="day-date">{{ day.dateLabel }}</span>
                        </span>
                        @if (hasManagementRole && day.users.length) {
                            <button (click)="approveDay(day.users)"
                                    aria-label="Alle uren van deze dag goedkeuren"
                                    class="day-approve d-print-none"
                                    mat-icon-button
                                    matTooltip="Alle uren van deze dag goedkeuren"
                                    type="button">
                                <i class="fa-regular fa-check-double"></i>
                            </button>
                        }
                        @if (singleUser && day.totalMinutes) {
                            <span [class.short]="day.short" class="day-total">{{ day.totalMinutes | formatDuration }}</span>
                        }
                    </div>
                    <div class="day-body">
                        @for (user of day.users; track user.userId) {
                            @if (!singleUser) {
                                <div class="user-head">
                                    <span>{{ user.name }}</span>
                                    <span class="ui-mono">{{ user.totalMinutes | formatDuration }}</span>
                                </div>
                            }
                            @for (row of user.rows; track $index) {
                                @if (row.entry; as registration) {
                                    <app-time-entry
                                        (contextmenu)="openContextMenu(registration, $event)"
                                        [client]="companies() | companyName: registration.company_id"
                                        [companyId]="registration.company_id"
                                        [end]="registration.endtime | date: 'HH:mm': 'UTC'"
                                        [path]="registration.project?.name"
                                        [start]="registration.starttime | date: 'HH:mm': 'UTC'"
                                        [state]="registrationState(registration)"
                                        [task]="registration.name">
                                        @for (comment of registration.comments; track comment.id) {
                                            <span class="comment">{{ comment.datetime | date: 'HH:mm': 'UTC' }} {{ comment.description }}</span>
                                        }
                                    </app-time-entry>
                                } @else {
                                    <app-pause-divider [minutes]="row.breakMinutes"></app-pause-divider>
                                }
                            }
                        } @empty {
                            <span class="day-empty">{{ day.emptyText }}</span>
                        }
                    </div>
                </div>
            }
            @for (day of days(); track day.date) {
                <div [class.weekend]="day.weekend" class="prs">
                    @if (day.prs.length) {
                        <div class="prs-title"><i class="fa-regular fa-code-pull-request"></i>Pull requests</div>
                        @for (pr of day.prs; track pr.id) {
                            <app-pr-card
                                [branch]="pr.branch"
                                [href]="pr.href"
                                [number]="pr.id"
                                [repo]="pr.repo"
                                [reviewers]="pr.reviewers"
                                [statusTone]="pr.statusTone"
                                [status]="pr.status"
                                [target]="pr.target"
                                [title]="pr.title"
                                [when]="pr.when"
                                [workItems]="pr.workItems"
                                variant="card">
                            </app-pr-card>
                        }
                    }
                </div>
            }
        </div>
    </section>
</app-page>

<ng-template #taskContextMenu>
    <div class="context-menu-panel">
        @if (contextMenuTask()) {
            <button (click)="approveHour(contextMenuTask().id)" class="context-menu-cell" type="button">
                <i class="fa-regular fa-circle-check"></i>Uur goedkeuren
            </button>
            <button (click)="disapproveHour(contextMenuTask().id)" class="context-menu-cell" type="button">
                <i class="fa-regular fa-circle-xmark"></i>Uur afkeuren
            </button>
            <button (click)="changeRegistrationProject(contextMenuTask())" class="context-menu-cell" type="button">
                <i class="fa-regular fa-folder-open"></i>Project aanpassen
            </button>
        } @else {
            <div class="context-menu-header">Uren niet gevonden</div>
        }
    </div>
</ng-template>
